module.exports = __webpack_public_path__ + "static/media/img_1.e13f5336.png";